<template>
  <div id="question-thread" class="report">
    <mu-row v-if="!isLoading" class="content" gutter>
      <mu-col width="100" desktop="70" tablet="70">
        <mu-card class="bottom">
          <mu-card-text class="userCard" v-if="!isLoading">
            <mu-avatar
              class="userImage"
              :size="90"
              v-if="!comment.user.avatar"
              color="#0179d5"
              backgroundColor="#E9E9E8"
              src="static/avatar.png">
            </mu-avatar>
            <mu-avatar class="userImage" :size="90" v-if="comment.user.avatar"
                       :src="comment.user.avatar"></mu-avatar>

            <div class="userBlock">
              <div>
                <router-link :to="{path: '/profile/' + comment.user.profile.url}">
                  {{encodeText(comment.user.display_name)}} <country-badge :alpha2="comment.user.country.alpha2" :tooltip="comment.user.country.country_name"></country-badge>
                </router-link>
              </div>
              <div class="blueLine">{{comment.user.diabetes_type}}</div>
            </div>

            <div class="badges">
              <user-badge v-if="comment.user.is_admin" type="support" mode="image"></user-badge>
              <user-badge v-if="comment.user.is_champion" type="champion" mode="image"></user-badge>
              <user-badge v-if="comment.user.is_complete" type="finished-program" mode="image"></user-badge>
            </div>

          </mu-card-text>
          <mu-card-text v-if="comment.comment">
              <vue-markdown :source="encodeText(comment.comment)"
                           style="white-space: pre-wrap;">

              </vue-markdown>
          </mu-card-text>
          <mu-card-actions>
            <mu-flat-button icon="history" label="Go to comment" @click.native="goToArticle()"></mu-flat-button>
          </mu-card-actions>
        </mu-card>
        <report v-if="reports.reasons.length" :typeId="parseInt($route.params.id)" type="LIFE_REPLY"></report>
      </mu-col>
      <mu-col width="100" desktop="30" tablet="30">
        <form @submit.prevent="submitForm" novalidate>
          <mu-card>
            <mu-card-header titleClass="blueTitle largeTitle" title="Handle report"></mu-card-header>
            <mu-card-text style="padding-top: 0">
              What do you want to do this with comment?
            </mu-card-text>
            <mu-card-text>
              <div>
                <mu-radio v-model="model.status" nativeValue="KEEP" label="Keep it (removes reports)"></mu-radio>
              </div>
              <div>
                <mu-radio v-model="model.status" nativeValue="REMOVE" label="Remove it"></mu-radio>
              </div>
            </mu-card-text>
            <button type="submit" style="display: none;"></button>
            <mu-card-actions align="right">
              <mu-raised-button type="button" @click.native="submitForm" label="Ammend" secondary></mu-raised-button>
            </mu-card-actions>
          </mu-card>
        </form>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import HTMLStringParser from '../../helpers/HTMLStringParser'
  import ReportingApi from '../../api/Reporting'
  import TitleManager from '../../helpers/TitleManager'
  import LifeStyleApi from '../../api/LifeStyle'

  import UserBadge from "../../components/UserBadge/UserBadge.vue";
  import CountryBadge from "../../components/CountryBadge/CountryBadge.vue"

  import Report from "../../components/Reporting/Report.vue";

  export default {
    components: {
      UserBadge,
      CountryBadge,
      Report,
    },
    data() {
      return {
        isLoading: true,
        comment: {},
        post: {},
        reports: {},
        isAmmending: false,
        model: {
          status: "REMOVE"
        }
      }
    },
    methods: {
      goToArticle() {
        let self = this;
        self.$router.push({
          name: 'LifeStyleArticle',
          params: {
            permalink: self.post.post_slug
          }
        })
      },
      submitForm() {
        let self = this;
        if (self.$validator.validateAll()) {
          self.isAmmending = true;
          if (self.model.status === 'REMOVE') {
            self.$alert({
              title: "Are you sure?",
              text: "Are you sure you want to remove the following comment, as well as all sub comments and reports",
              type: "warning",
              showCancelButton: true,
              showLoaderOnConfirm: false,
              confirmButtonColor: "white",
              cancelButtonColor: "white",
              preConfirm: function () {
                let model = {
                  comment_id: self.$route.params.id,
                  level: 0,
                  post_id: self.post.post_id
                }
                return LifeStyleApi.deleteComment(model);
              }
            })
            .then(function (response) {
              self.$toastr.success('Comment successfully removed');
              self.goToArticle();
            }.bind(self))
            .catch(self.$alert.noop);
          }
          if (self.model.status === 'KEEP') {
            self.$alert({
              title: "Are you sure?",
              text: "Are you sure you want keep the comment and remove all reports",
              type: "warning",
              showCancelButton: true,
              showLoaderOnConfirm: false,
              confirmButtonColor: "white",
              cancelButtonColor: "white",
              preConfirm: function () {
                return ReportingApi.removeReports("LIFE_REPLY", self.$route.params.id)
              }
            })
            .then(function (response) {
              self.$toastr.success('All reports for this comments have been removed');
              self.goToArticle();
            }.bind(self))
            .catch(self.$alert.noop);
          }
        }
      },
      encodeText(string) {
        return HTMLStringParser.encode(string);
      },
      loadLifeReports() {
        let self = this;
        self.isLoading = true;
        TitleManager.setTitle(self.$t('message.loadingText'));
        ReportingApi.getLifeReports(self.$route.params.id, 'LIFE_REPLY').then((response) => {
          self.comment = response.data.comment;
          self.post = response.data.post;
          self.reports = response.data.report;
          TitleManager.setTitle(self.post.post_title);
          self.isLoading = false;
          if ( self.reports.reasons.length === 0 ) {
            self.goToArticle();
          }
        }).catch((error) => {
          if(error.response.data) {
            self.$router.push({
              name: 'Dashboard'
            })
          }
        });
      }
    },
    mounted() {
      let self = this;
      self.loadLifeReports();
    }
  }

</script>
<style lang="less">
  @import '../Questions/Questions.less';
</style>



// WEBPACK FOOTER //
// LifeReplyReport.vue?1b4e6034